export const ROLE_OPTIONS = [
  { value: "admin", label: "Administrador" },
  { value: "ejecutivo1", label: "Ejecutivo 1" },
  { value: "ejecutivo2", label: "Ejecutivo 2" },
  { value: "cobrador", label: "Cobrador" },
  { value: "vendedor", label: "Vendedor" },
  { value: "comisionista", label: "Comisionista" },
];

export const PERMISSION_GROUPS = [
  {
    key: "clientes",
    label: "Clientes",
    permissions: [
      { key: "clientes.ver", label: "Ver clientes" },
      { key: "clientes.crear", label: "Crear cliente" },
      { key: "clientes.editar", label: "Editar cliente" },
      { key: "clientes.subirDocumentos", label: "Subir documentos" },
      { key: "clientes.verDocumentos", label: "Ver documentos" },
    ],
  },
  {
    key: "deudas",
    label: "Deudas",
    permissions: [
      { key: "deudas.ver", label: "Ver deudas" },
      { key: "deudas.crear", label: "Crear deuda" },
      { key: "deudas.editar", label: "Editar deuda" },
      { key: "deudas.desactivar", label: "Desactivar deuda" },
      { key: "deudas.iniciarDevolucion", label: "Iniciar devolucion" },
      { key: "deudas.registrarPago", label: "Registrar pago" },
      { key: "deudas.editarPago", label: "Editar pago" },
      { key: "deudas.eliminarPago", label: "Eliminar pago" },
      { key: "deudas.descargarPDF", label: "Descargar PDF" },
    ],
  },
  {
    key: "usuarios",
    label: "Usuarios",
    permissions: [
      { key: "usuarios.ver", label: "Ver usuarios" },
      { key: "usuarios.crear", label: "Crear usuarios" },
      { key: "usuarios.editar", label: "Editar usuarios" },
      { key: "usuarios.eliminar", label: "Eliminar usuarios" },
      { key: "usuarios.cambiarRol", label: "Cambiar rol" },
      { key: "usuarios.editarPermisos", label: "Editar permisos por rol" },
      { key: "auditoria.ver", label: "Ver auditoria" },
    ],
  },
  {
    key: "propiedades",
    label: "Propiedades",
    permissions: [
      { key: "propiedades.ver", label: "Ver propiedades" },
      { key: "propiedades.crear", label: "Crear propiedad" },
      { key: "propiedades.editar", label: "Editar propiedad" },
      { key: "propiedades.vender", label: "Vender propiedad" },
    ],
  },
  {
    key: "tickets",
    label: "Tickets",
    permissions: [
      { key: "tickets.ver", label: "Ver tickets" },
      { key: "tickets.crear", label: "Crear ticket" },
      { key: "tickets.asignar", label: "Asignar ticket" },
      { key: "tickets.cerrar", label: "Cerrar ticket" },
      { key: "tickets.comentar", label: "Comentar ticket" },
      { key: "tickets.adjuntar", label: "Adjuntar archivos" },
    ],
  },
  {
    key: "agenda",
    label: "Agenda",
    permissions: [
      { key: "agenda.ver", label: "Ver agenda" },
      { key: "agenda.registrarMovimiento", label: "Registrar movimiento" },
      { key: "agenda.reprogramar", label: "Reprogramar" },
    ],
  },
  {
    key: "reportes",
    label: "Reportes",
    permissions: [
      { key: "reportes.ver", label: "Ver reportes" },
      { key: "reportes.exportar", label: "Exportar reportes" },
      { key: "reportes.exportarTickets", label: "Exportar tickets" },
      { key: "reportes.exportarCxp", label: "Exportar CxP" },
      { key: "reportes.exportarCxc", label: "Exportar CxC" },
    ],
  },
  {
    key: "erp",
    label: "ERP",
    permissions: [
      { key: "erp.ver", label: "Ver ERP" },
      { key: "erp.recalcular", label: "Recalcular ERP" },
      { key: "erp.gestionInterna", label: "Gestion interna" },
    ],
  },
  {
    key: "gestionInterna",
    label: "Gestion interna",
    permissions: [
      { key: "gestionInterna.ver", label: "Ver gestion interna" },
      { key: "cxp.ver", label: "Ver CxP" },
      { key: "cxp.crear", label: "Crear CxP" },
      { key: "cxp.editar", label: "Editar CxP" },
      { key: "cxp.registrarPago", label: "Registrar pagos CxP" },
      { key: "cxp.cancelar", label: "Cancelar CxP" },
      { key: "proveedores.ver", label: "Ver proveedores" },
      { key: "proveedores.crear", label: "Crear proveedores" },
      { key: "proveedores.editar", label: "Editar proveedores" },
    ],
  },
  {
    key: "obras",
    label: "Obras",
    permissions: [
      { key: "obras.ver", label: "Ver obras" },
      { key: "obras.crear", label: "Crear obra" },
      { key: "obras.editar", label: "Editar obra/objetivos" },
      { key: "obras.eliminar", label: "Eliminar obra/objetivos" },
    ],
  },
  {
    key: "proyectos",
    label: "Proyectos",
    permissions: [
      { key: "proyectos.ver", label: "Ver proyectos" },
      { key: "proyectos.crear", label: "Crear proyecto" },
      { key: "proyectos.editar", label: "Renombrar proyecto" },
      { key: "proyectos.eliminar", label: "Eliminar proyecto" },
      { key: "proyectos.archivos", label: "Gestionar archivos" },
    ],
  },
  {
    key: "cajas",
    label: "Cajas por proyecto",
    permissions: [
      { key: "cajas.ver", label: "Ver cajas por proyecto" },
      { key: "cajas.crearMovimiento", label: "Crear movimientos de caja" },
      { key: "cajas.cancelarMovimiento", label: "Cancelar movimientos de caja" },
      { key: "cajas.importarHistorico", label: "Importar pagos historicos" },
      { key: "cajas.conciliar", label: "Conciliar caja" },
      { key: "cajas.cerrarCorte", label: "Cerrar cortes de caja" },
      { key: "cajas.reabrirCorte", label: "Reabrir cortes de caja" },
      { key: "cajas.exportar", label: "Exportar cajas" },
      { key: "cajas.general.ver", label: "Ver caja general" },
      { key: "cajas.general.crearMovimiento", label: "Crear movimientos generales" },
      { key: "cajas.transferir", label: "Transferir entre cajas" },
      { key: "cajas.clusters.ver", label: "Ver clusters de caja" },
      { key: "cajas.clusters.crear", label: "Crear clusters de caja" },
      { key: "cajas.clusters.editar", label: "Editar clusters de caja" },
      { key: "cajas.clusters.cerrarCorte", label: "Cerrar cortes de cluster" },
    ],
  },
  {
    key: "socios",
    label: "Socios",
    permissions: [
      { key: "socios.ver", label: "Ver socios" },
      { key: "socios.crear", label: "Crear socio" },
      { key: "socios.editar", label: "Editar socio" },
    ],
  },
  {
    key: "cobranzaInteligente",
    label: "Cobranza inteligente",
    permissions: [
      { key: "cobranzaInteligente.ver", label: "Ver cobranza inteligente" },
    ],
  },
  {
    key: "cobranzaOperativa",
    label: "Cobranza operativa",
    permissions: [
      { key: "cobranza.promesas.ver", label: "Ver promesas de pago" },
      { key: "cobranza.promesas.crear", label: "Crear promesas de pago" },
      { key: "cobranza.promesas.editar", label: "Editar promesas de pago" },
      { key: "cobranza.gestiones.ver", label: "Ver gestiones" },
      { key: "cobranza.gestiones.crear", label: "Crear gestiones" },
    ],
  },
  {
    key: "comisiones",
    label: "Comisiones",
    permissions: [
      { key: "comisiones.ver", label: "Ver comisiones (todas)" },
      { key: "comisiones.crear", label: "Crear comisión al cerrar venta" },
      { key: "comisiones.editar", label: "Editar comisión (esquema/monto)" },
      { key: "comisiones.cancelar", label: "Cancelar comisión" },
      { key: "comisiones.miCuenta.ver", label: "Ver mi cuenta de comisionista" },
      { key: "comisionistas.gestionar", label: "Alta y edición de comisionistas" },
    ],
  },
];

export const ALL_PERMISSION_KEYS = PERMISSION_GROUPS.flatMap((group) =>
  group.permissions.map((permission) => permission.key)
);

const makePermissions = (allowed) =>
  ALL_PERMISSION_KEYS.reduce((acc, permission) => {
    acc[permission] = allowed === true || allowed.includes(permission);
    return acc;
  }, {});

export const DEFAULT_ROLE_DEFINITIONS = {
  admin: {
    nombre: "Administrador",
    descripcion: "Acceso completo a todas las funciones.",
    protected: true,
    permisos: makePermissions(true),
  },
  ejecutivo1: {
    nombre: "Ejecutivo 1",
    descripcion: "Gestion operativa avanzada y administracion de usuarios.",
    permisos: makePermissions([
      "clientes.ver",
      "clientes.crear",
      "clientes.editar",
      "clientes.subirDocumentos",
      "clientes.verDocumentos",
      "deudas.ver",
      "deudas.crear",
      "deudas.editar",
      "deudas.desactivar",
      "deudas.iniciarDevolucion",
      "deudas.registrarPago",
      "deudas.editarPago",
      "deudas.eliminarPago",
      "deudas.descargarPDF",
      "usuarios.ver",
      "usuarios.crear",
      "usuarios.editar",
      "usuarios.cambiarRol",
      "usuarios.editarPermisos",
      "auditoria.ver",
      "propiedades.ver",
      "propiedades.crear",
      "propiedades.editar",
      "propiedades.vender",
      "tickets.ver",
      "tickets.crear",
      "tickets.asignar",
      "tickets.cerrar",
      "tickets.comentar",
      "tickets.adjuntar",
      "agenda.ver",
      "agenda.registrarMovimiento",
      "agenda.reprogramar",
      "reportes.ver",
      "reportes.exportar",
      "reportes.exportarTickets",
      "reportes.exportarCxp",
      "reportes.exportarCxc",
      "erp.ver",
      "erp.recalcular",
      "erp.gestionInterna",
      "gestionInterna.ver",
      "cxp.ver",
      "cxp.crear",
      "cxp.editar",
      "cxp.registrarPago",
      "cxp.cancelar",
      "proveedores.ver",
      "proveedores.crear",
      "proveedores.editar",
      "obras.ver",
      "obras.crear",
      "obras.editar",
      "obras.eliminar",
      "proyectos.ver",
      "proyectos.crear",
      "proyectos.editar",
      "proyectos.eliminar",
      "proyectos.archivos",
      "cajas.ver",
      "cajas.crearMovimiento",
      "cajas.cancelarMovimiento",
      "cajas.importarHistorico",
      "cajas.conciliar",
      "cajas.cerrarCorte",
      "cajas.reabrirCorte",
      "cajas.exportar",
      "cajas.general.ver",
      "cajas.general.crearMovimiento",
      "cajas.transferir",
      "cajas.clusters.ver",
      "cajas.clusters.crear",
      "cajas.clusters.editar",
      "cajas.clusters.cerrarCorte",
      "socios.ver",
      "socios.crear",
      "socios.editar",
      "cobranzaInteligente.ver",
      "cobranza.promesas.ver",
      "cobranza.promesas.crear",
      "cobranza.promesas.editar",
      "cobranza.gestiones.ver",
      "cobranza.gestiones.crear",
      "comisiones.ver",
      "comisiones.crear",
      "comisiones.editar",
      "comisionistas.gestionar",
    ]),
  },
  ejecutivo2: {
    nombre: "Ejecutivo 2",
    descripcion: "Gestion operativa sin acciones sensibles sobre pagos o devoluciones.",
    permisos: makePermissions([
      "clientes.ver",
      "clientes.crear",
      "clientes.editar",
      "clientes.subirDocumentos",
      "clientes.verDocumentos",
      "deudas.ver",
      "deudas.crear",
      "deudas.editar",
      "deudas.registrarPago",
      "deudas.descargarPDF",
      "propiedades.ver",
      "propiedades.crear",
      "propiedades.editar",
      "propiedades.vender",
      "tickets.ver",
      "tickets.crear",
      "tickets.asignar",
      "tickets.cerrar",
      "tickets.comentar",
      "tickets.adjuntar",
      "agenda.ver",
      "agenda.registrarMovimiento",
      "agenda.reprogramar",
      "reportes.ver",
      "reportes.exportar",
      "reportes.exportarTickets",
      "reportes.exportarCxp",
      "reportes.exportarCxc",
      "erp.ver",
      "erp.gestionInterna",
      "gestionInterna.ver",
      "cxp.ver",
      "cxp.crear",
      "cxp.editar",
      "proveedores.ver",
      "proveedores.crear",
      "proveedores.editar",
      "obras.ver",
      "obras.crear",
      "obras.editar",
      "proyectos.ver",
      "proyectos.crear",
      "proyectos.editar",
      "proyectos.archivos",
      "cajas.ver",
      "cajas.conciliar",
      "cajas.exportar",
      "cajas.general.ver",
      "cajas.clusters.ver",
      "socios.ver",
      "socios.crear",
      "socios.editar",
      "cobranzaInteligente.ver",
      "cobranza.promesas.ver",
      "cobranza.promesas.crear",
      "cobranza.gestiones.ver",
      "cobranza.gestiones.crear",
      "comisiones.ver",
      "comisiones.crear",   // puede capturar comisión al cerrar una venta
    ]),
  },
  cobrador: {
    nombre: "Cobrador",
    descripcion: "Cobranza, pagos y seguimiento de agenda.",
    permisos: makePermissions([
      "clientes.ver",
      "clientes.verDocumentos",
      "deudas.ver",
      "deudas.registrarPago",
      "deudas.descargarPDF",
      "cobranza.promesas.ver",
      "cobranza.promesas.crear",
      "cobranza.gestiones.ver",
      "cobranza.gestiones.crear",
      "tickets.ver",
      "tickets.crear",
      "tickets.comentar",
      "tickets.adjuntar",
      "agenda.ver",
      "agenda.registrarMovimiento",
      "agenda.reprogramar",
      "reportes.ver",
      "reportes.exportarCxp",
      "reportes.exportarCxc",
    ]),
  },
  vendedor: {
    nombre: "Vendedor",
    descripcion: "Alta y consulta comercial basica.",
    permisos: makePermissions([
      "clientes.ver",
      "clientes.crear",
      "clientes.editar",
      "clientes.subirDocumentos",
      "clientes.verDocumentos",
      "propiedades.ver",
      "tickets.ver",
      "tickets.crear",
      "tickets.comentar",
      "tickets.adjuntar",
      "reportes.ver",
      "comisiones.ver",
    ]),
  },
  comisionista: {
    nombre: "Comisionista",
    descripcion: "Vendedor externo con acceso únicamente a su cuenta personal de comisiones.",
    permisos: makePermissions([
      "comisiones.miCuenta.ver",
    ]),
  },
};

// Permisos reservados exclusivamente al rol admin. Cualquier otro rol los
// tendrá denegados en el cap aunque sus defaults o el documento roles/{rol}
// en Firestore intenten activarlos.
const ADMIN_ONLY_PERMISSIONS = [
  // Gestión de usuarios y de la matriz de permisos
  "usuarios.crear",
  "usuarios.editar",
  "usuarios.cambiarRol",
  "usuarios.editarPermisos",
  // Hub administrativo / configuración interna
  "gestionInterna.ver",
  "erp.gestionInterna",
  "erp.recalcular",
  // Borrados duros
  "obras.eliminar",
  "proyectos.eliminar",
  // Manipulación contable sensible
  "cajas.importarHistorico",
  "cajas.reabrirCorte",
  // Acciones financieras destructivas
  "cxp.cancelar",
  "deudas.desactivar",
  "deudas.iniciarDevolucion",
  "deudas.eliminarPago",
  // Comisiones: cancelación es admin-only por irreversible
  "comisiones.cancelar",
  // Eliminación de usuarios — solo admin puede borrar cuentas
  "usuarios.eliminar",
];

const restrictCap = (basePermisos) => {
  const result = { ...basePermisos };
  ADMIN_ONLY_PERMISSIONS.forEach((permission) => {
    result[permission] = false;
  });
  return result;
};

// LIMPIA (2026-06-17): honestidad de defaults. Antes algunos roles no-admin
// (notablemente ejecutivo1) listaban permisos admin-only en sus defaults que
// el cap ya negaba → la matriz mostrada "prometía" permisos que el rol nunca
// obtiene. Aquí saneamos los defaults para que coincidan con lo realmente
// concedido. El cap sigue siendo la última palabra; esto solo evita confusión
// en la UI de roles y al seedear Firestore. Hecho programáticamente para no
// arriesgar typos editando los arreglos a mano.
Object.keys(DEFAULT_ROLE_DEFINITIONS).forEach((role) => {
  if (role === "admin") return;
  const permisos = DEFAULT_ROLE_DEFINITIONS[role].permisos;
  ADMIN_ONLY_PERMISSIONS.forEach((permission) => {
    if (permisos[permission]) permisos[permission] = false;
  });
});

export const ROLE_PERMISSION_CAPS = {
  admin: makePermissions(true),
  // ejecutivo1 puede hacer todo lo operativo pero no toca la administración
  // del sistema (usuarios/permisos/configuración) ni acciones destructivas.
  ejecutivo1: restrictCap(DEFAULT_ROLE_DEFINITIONS.ejecutivo1.permisos),
  ejecutivo2: restrictCap(DEFAULT_ROLE_DEFINITIONS.ejecutivo2.permisos),
  cobrador: restrictCap(DEFAULT_ROLE_DEFINITIONS.cobrador.permisos),
  vendedor: restrictCap(DEFAULT_ROLE_DEFINITIONS.vendedor.permisos),
  comisionista: restrictCap(DEFAULT_ROLE_DEFINITIONS.comisionista.permisos),
};

export const getDefaultRoleDefinition = (role) =>
  DEFAULT_ROLE_DEFINITIONS[role] || null;

export const getDefaultPermissions = (role) =>
  getDefaultRoleDefinition(role)?.permisos || {};

export const getRolePermissionCaps = (role) =>
  ROLE_PERMISSION_CAPS[role] || {};
